<template>
  <f7-page class="main-massive-records-new">
    <template #fixed>
      <TheNavbar
        :style="appTheme"
        nav-title="Marcajes Masivos"
        back-btn-enable
      >
        <template #btn-right>
          <img
            src="@/static/icons/ic_config_white.svg"
            width="37"
            @click="popupConfiguration = true"
          >
        </template>
      </TheNavbar>
    </template>

    <div
      class="content-massive-records-new-filter padding-half"
    >
      <span> Buscar trabajador para nuevo marcaje </span>

      <f7-block class="content-massive-records-new-filter__block">
        <div class="content-massive-records-new-filter__block--input">
          <input
            type="text"
            class="input-search"
            :style="[{ width: '-webkit-fill-available' }]"
            data-testid="search-input-element-id"
            placeholder="Núm. trabajador, Nombre, Primer Apellido..."
            :value="searchFieldValue"
            @input="searchFieldValue = /** @type {HTMLInputElement} */ ($event.target).value"
            @keypress.enter="handleEnter"
          >
          <div :style="[{ 'padding-right': '16px' }]">
            <img
              class="selectable"
              src="@/static/icons/ic_search.svg"
              width="24"
              height="24"
              @click="searchWorkers"
            >
          </div>
        </div>
        <div class="div-qr-search">
          <img
            src="@/static/icons/qr-code.svg"
            @click="codeScannerRef?.Open()"
          >
        </div>
      </f7-block>
    </div>
    <div class="content-massive-records-new-information">
      <PCMassRecords
        v-model:workers-list="workersList"
        class="content-massive-records-new-information__list"
        :record-date="dateRedWorker"
        @delete="deleteWorker"
      />

      <f7-block>
        <div class="content-massive-records-new-information__data">
          <UCSearchEntityERP
            ref="searchProductionLineRef"
            title="Selecciona la línea de producción"
            placeholder="Código línea produción…"
            search-text="Buscando líneas de producción…"
            search-cancellation-text="Búsqueda línea cancelada…"
            search-not-found-text="Línea no encontrada"
            :default-value="lineaDeProduccionSeleccionada"
            :property-entity-shown-input="['Codigo', 'Nombre']"
            :property-entity-shown-list-title="['Codigo']"
            :property-entity-shown-list-subtitle="['Nombre']"
            :min-text-search="0"
            :next-and-previous-buttons-shown="false"
            :autofocus-on-deselection="true"
            :auto-focus-on-empty-search-result="true"
            :emit-evet-change-default-value="true"
            :default-etities-list="sortedProductionLines"
            :disabled="selectedActivity != null && !isProductionActivity(selectedActivity)"
            @selection="eventSelectedProductionLine"
          />

          <UCSearchEntityERP
            ref="searchActivityRef"
            title="Selecciona la actividad de producción"
            placeholder="Código actividad produción…"
            search-text="Buscando actividades de producción…"
            search-cancellation-text="Búsqueda actividades cancelada…"
            search-not-found-text="Actividad no encontrada"
            :end-point-for-code-search="activityCodeSearch"
            :end-point-for-list="activityList"
            :property-entity-shown-input="['Codigo', 'Nombre']"
            :property-entity-shown-list-title="['Codigo']"
            :property-entity-shown-list-subtitle="['Nombre']"
            class="padding-bottom-half"
            @selection="eventSelectedProductionActivity"
          />

          <UCDatePicker
            ref="datePickerRef"
            title="Fecha de marcaje"
            @onchange="handleDateChange"
          />
          <UCTimePicker
            ref="timePickerRef"
            :show-input="false"
            template="P2"
            title="Hora Marcaje"
            :show-seconds="true"
            @onchange="handleTimeChange"
          />

          <div class="content-massive-records-new-information__data--button">
            <f7-button
              fill
              color="steel-blue"
              @click="handleGenerateRecord"
            >
              Generar Marcaje
            </f7-button>
          </div>
        </div>
      </f7-block>
    </div>

    <UCCodeScanner
      ref="codeScannerRef"
      :fab-button-show="false"
      :allow-manual-code-entry="true"
      :autofocus-on-input="false"
      :auto-open-camera="true"
      :continuous-bar-code-reading="workerContinuousReading"
      @code-reading="eventCodeScannerRead"
      @codigo-barras="eventCodeScannerRead"
    />

    <f7-popup
      :tablet-fullscreen="true"
      class="new-massive-records-popup"
      :opened="popupNewRecords"
      @popup:closed="closeNewRecordsPopUp"
    >
      <TheNavbar
        :style="appTheme"
        nav-title="Crear marcajes masivos"
        popup-close-btn-enable
      />

      <div class="content-new-massive-records-popup">
        <div class="content-new-massive-records-popup__searchbar">
          <span class="content-new-massive-records-popup__searchbar--title"> Filtro trabajador para nuevo marcaje </span>
          <f7-searchbar
            v-model:value="searchWorkerNameValue"
            placeholder="Introduce nombre del trabajador"
            :clear-button="true"
          />
        </div>
        <f7-list accordion-list>
          <f7-list-item
            class="content-new-massive-records-popup__accordion-list"
            accordion-item
            :accordion-item-opened="false"
            title="Otros filtros"
            @accordion:open="accordeonOpen = true"
            @accordion:close="accordeonOpen = false"
          >
            <f7-accordion-content class="content-new-massive-records-popup__accordion-list--content">
              <UCSearchEntityERP
                ref="searchFilterProductionLineRef"
                title="Líneas de producción"
                placeholder="Código línea produción…"
                search-text="Buscando líneas de producción…"
                search-cancellation-text="Búsqueda línea cancelada…"
                search-not-found-text="Línea no encontrada"
                :property-entity-shown-input="['Codigo', 'Nombre']"
                :property-entity-shown-list-title="['Codigo']"
                :property-entity-shown-list-subtitle="['Nombre']"
                :autofocus-on-deselection="true"
                :auto-focus-on-empty-search-result="true"
                :emit-evet-change-default-value="true"
                :default-etities-list="productionLineFilterList"
                @selection="eventSelectedProductionLineFilter"
              />

              <UCSearchEntityERP
                ref="searchFilterActivityRef"
                title="Actividad de producción"
                placeholder="Código actividad produción…"
                search-text="Buscando actividades de producción…"
                search-cancellation-text="Búsqueda actividades cancelada…"
                search-not-found-text="Actividad no encontrada"
                :property-entity-shown-input="['Codigo', 'Nombre']"
                :property-entity-shown-list-title="['Codigo']"
                :property-entity-shown-list-subtitle="['Nombre']"
                class="padding-bottom-half"
                :default-etities-list="productionActivityFilterList"
                @selection="eventSelectedProductionActivityFilter"
              />

              <UCSearchEntityERP
                ref="searchFilterWorkerGroupRef"
                title="Grupo de trabajadores"
                placeholder="Grupo de trabajadores…"
                search-text="Buscando grupo de trabajadores…"
                search-cancellation-text="Grupo de trabajadores cancelada…"
                search-not-found-text="Grupo de trabajadores no encontrado"
                :property-entity-shown-input="['Descripcion', 'Codigo']"
                :property-entity-shown-list-title="['Descripcion']"
                :property-entity-shown-list-subtitle="['Codigo']"
                class="padding-bottom-half"
                :default-etities-list="workersGroupFilter"
                @selection="eventSelectedWorkersGroupFilter"
              />
            </f7-accordion-content>
          </f7-list-item>
        </f7-list>
      </div>
      <div>
        <PCMassRecords
          ref="massRecordsPopupRef"
          v-model:workers-list="workersListFilter"
          class="content-massive-records-new-information__list searchbar-found"
          :class="{ opened: accordeonOpen }"
          :select-worker-option="true"
          :delete-worker-option="false"
        />
      </div>

      <div class="content-new-massive-records-popup__button padding-half">
        <f7-button
          fill
          @click="handleWorkersFilterConfirmation"
        >
          Confirmar
        </f7-button>
      </div>
    </f7-popup>

    <f7-popup
      class="new-massive-records-configuration-popup"
      :opened="popupConfiguration"
      @popup:closed="popupConfiguration = false"
    >
      <TheNavbar
        :style="appTheme"
        nav-title="Configuración"
        popup-close-btn-enable
      />

      <f7-block class="display-flex justify-content-space-between">
        <span class=""> Lectura de trabajadores continua </span>
        <f7-toggle @change="workerContinuousReading = !workerContinuousReading" />
      </f7-block>
    </f7-popup>
  </f7-page>
</template>

<script setup>
// @ts-check
import { useTraceabilityStore } from '@/js/stores/traceability';
import { useParamRef } from '@erpagroapp/params';
import { useAppConfigStore } from '@/js/stores/appConfig';
import APIErp, { callExecuteSPERP } from '@/js/services/APIErp';
import { storeToRefs } from 'pinia';

import TheNavbar from '@/components/TheNavbar.vue';
import UCCodeScanner from '@/components/common/UCCodeScanner.vue';
import PCMassRecords from '@/components/production/workerElementProduction/PCMassRecords.vue';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import UCDatePicker from '@/components/common/UCDatePicker.vue';
import UCTimePicker from '@/components/common/UCTimePicker.vue';

import { HiDateTimeSupport } from '@/js/common/HIConversionSupport';
import { HiDialog, HiNotification } from '@/js/common/HINotificationSupport';
import { useSortedProductionLines } from '@/composables/useSortedProductionLines';
import {
  computed,
  reactive,
  ref,
  shallowRef,
  watch,
} from 'vue';
import { logError } from '@/js/utils/log';

/** @import { Ref, ShallowRef } from 'vue' */
/** @import {
 * ActividadProduccion,
 * GrupoTrabajadores,
 * LineaProduccion,
 * MarcajeCerco,
 * Trabajador,
 * } from '@erpagroapp/types' */

/** @typedef {Trabajador & { checked?: boolean }} LocalTrabajador */

const { sortedProductionLines } = useSortedProductionLines();

/** @type {Ref<ActividadProduccion | null>} */
const selectedActivity = ref(null);
const dateTimeNewRecord = ref('');
const dateNewRecord = ref('');
const dateRedWorker = ref('');
const timeNewRecord = ref('00:00');
/** @type {Ref<LocalTrabajador[]>} */
const workersList = ref([]);
/** @type {Ref<LocalTrabajador[]>} */
const workersListFilter = ref([]);
/** @type {Ref<LocalTrabajador[]>} */
const completeList = ref([]);
/** @type {Ref<LineaProduccion | null>} */
const selectedProductionLine = ref(null);
const popupNewRecords = ref(false);
const popupConfiguration = ref(false);
const workerContinuousReading = ref(false);
/** @type {Ref<GrupoTrabajadores[]>} */
const workersGroupFilter = ref([]);
/** @type {Ref<LineaProduccion[]>} */
const productionLineFilterList = ref([]);
/** @type {Ref<ActividadProduccion[]>} */
const productionActivityFilterList = ref([]);
const accordeonOpen = ref(false);
const searchFieldValue = ref('');
const filters = reactive({
  /** @type {ActividadProduccion | null} */
  activity: null,
  /** @type {LineaProduccion | null} */
  productionLine: null,
  /** @type {GrupoTrabajadores | null} */
  workersGroup: null,
});
const prefijoTrabajadoresAlmacen = useParamRef('PrefijoTrabajadoresAlmacen');

/** @type {ShallowRef<InstanceType<typeof PCMassRecords> | null>} */
const massRecordsPopupRef = shallowRef(null);
/** @type {ShallowRef<InstanceType<typeof UCSearchEntityERP> | null>} */
const searchProductionLineRef = shallowRef(null);
/** @type {ShallowRef<InstanceType<typeof UCSearchEntityERP> | null>} */
const searchActivityRef = shallowRef(null);

/** @type {ShallowRef<InstanceType<typeof UCSearchEntityERP> | null>} */
const searchFilterProductionLineRef = shallowRef(null);
/** @type {ShallowRef<InstanceType<typeof UCSearchEntityERP> | null>} */
const searchFilterActivityRef = shallowRef(null);
/** @type {ShallowRef<InstanceType<typeof UCSearchEntityERP> | null>} */
const searchFilterWorkerGroupRef = shallowRef(null);

/** @type {ShallowRef<InstanceType<typeof UCTimePicker> | null>} */
const timePickerRef = shallowRef(null);
/** @type {ShallowRef<InstanceType<typeof UCDatePicker> | null>} */
const datePickerRef = shallowRef(null);
/** @type {ShallowRef<InstanceType<typeof UCCodeScanner> | null>} */
const codeScannerRef = shallowRef(null);

const {
  userEnviroment,
} = storeToRefs(useAppConfigStore());
const {
  lineaDeProduccionSeleccionada,
} = storeToRefs(useTraceabilityStore());

const searchWorkerNameValue = ref('');
watch(searchWorkerNameValue, () => {
  applyFilters();
});

const appTheme = computed(() => ({
  '--f7-navbar-bg-color': 'var(--his-slate-blue)',
}));

/**
 * @param {KeyboardEvent} event
 * @returns {void}
 */
function handleEnter(event) {
  if (event.key === 'Enter') {
    event.preventDefault();
    getProductionElementWorkerByDate(searchFieldValue.value);
  }
}

async function searchWorkers() {
  await getProductionElementWorkerByDate(searchFieldValue.value);
}

/**
 * @param {Date | null} value
 * @returns {void}
 */
function handleDateChange(value) {
  dateNewRecord.value = `${HiDateTimeSupport.FormatDateTime(value, 'DD/MM/YYYY')}`;
  dateTimeNewRecord.value = `${dateNewRecord.value}  ${timeNewRecord.value}`;
  dateRedWorker.value = `${HiDateTimeSupport.FormatDateTime(value, 'MM/DD/YYYY')}  ${timeNewRecord.value}`;
}

/**
 * @param {string} value
 * @returns {void}
 */
function handleTimeChange(value) {
  timeNewRecord.value = value;
  dateTimeNewRecord.value = `${dateNewRecord.value} ${value}`;

  const partes = dateRedWorker.value.split(' ');
  dateRedWorker.value = `${partes[0]} ${timeNewRecord.value}`;
}

function closeNewRecordsPopUp() {
  popupNewRecords.value = false;
  searchFilterActivityRef.value?.Clear();
  searchFilterProductionLineRef.value?.Clear();
  searchFilterWorkerGroupRef.value?.Clear();
}

function getProductionLineFilter() {
  const productionLineSet = new Set();
  productionLineFilterList.value = [];

  workersListFilter.value.forEach((worker) => {
    worker.TrabajadorElementoProduccion?.forEach((element) => {
      if (element.LineaProduccion && !productionLineSet.has(element.LineaProduccion.Id)) {
        productionLineSet.add(element.LineaProduccion.Id);
        productionLineFilterList.value.push(element.LineaProduccion);
      }
    });
  });
}

function getProductionActivityFilter() {
  const activitySet = new Set();
  productionActivityFilterList.value = [];

  workersListFilter.value.forEach((worker) => {
    worker.TrabajadorElementoProduccion?.forEach((element) => {
      if (element.ActividadProduccion && !activitySet.has(element.ActividadProduccion.Id)) {
        activitySet.add(element.ActividadProduccion.Id);
        productionActivityFilterList.value.push(element.ActividadProduccion);
      }
    });
  });
}

function getWorkersGroupFilter() {
  const uniqueGroups = new Set();
  /** @type {GrupoTrabajadores[]} */
  const tempWorkersGroup = [];

  workersListFilter.value.forEach((worker) => {
    worker.GruposTrabajadores?.forEach((wg) => {
      if (wg !== null && !uniqueGroups.has(wg.Id)) {
        uniqueGroups.add(wg.Id);
        tempWorkersGroup.push(wg);
      }
    });
  });

  workersGroupFilter.value = tempWorkersGroup;
}

/**
 * @param {ActividadProduccion | null} objActivity
 * @returns {boolean}
 */
function isProductionActivity(objActivity) {
  if (!objActivity) {
    return false;
  }

  if (objActivity.Codigo === 'PRE') {
    return false;
  }

  if (objActivity.Codigo === 'ASE') {
    return false;
  }

  return true;
}

/**
 * @param {LocalTrabajador} worker
 * @returns {void}
 */
function deleteWorker(worker) {
  workersList.value = workersList.value.filter((f) => f.Id !== worker.Id);
  massRecordsPopupRef.value?.changeChecked(worker, false);
}

/**
 * @param {string} value
 * @returns {void}
 */
function eventCodeScannerRead(value) {
  getProductionElementWorkerByDate(value);
}

/**
 * @param {LineaProduccion | null} objLine
 * @returns {Promise<void>}
 */
async function eventSelectedProductionLine(objLine) {
  selectedProductionLine.value = objLine;
  if (selectedProductionLine.value != null) {
    HiDialog.Preloader(true);
    const result = await activityList();
    if (result != null && result.status === 200 && result.data.length === 1) {
      searchActivityRef.value?.SelectEntity(result.data[0], false);
      // eslint-disable-next-line prefer-destructuring
      selectedActivity.value = result.data[0];
    }
    HiDialog.Preloader(false);
  } else if (selectedActivity.value != null && isProductionActivity(selectedActivity.value)) {
    searchActivityRef.value?.Clear({
      autoFocus: false,
    });
  }
}

/**
 * @param {ActividadProduccion | null} objActivity
 * @returns {Promise<void>}
 */
async function eventSelectedProductionActivity(objActivity) {
  selectedActivity.value = objActivity;
  if (selectedActivity.value != null) {
    if (!isProductionActivity(selectedActivity.value)) {
      searchProductionLineRef.value?.Clear();
    } else {
      HiDialog.Preloader(true);
      const result = await productionLineList();
      if (result != null && result.status === 200 && result.data.length === 1) {
        searchProductionLineRef.value?.SelectEntity(result.data[0], false);
        // eslint-disable-next-line prefer-destructuring
        selectedProductionLine.value = result.data[0];
      }
      HiDialog.Preloader(false);
    }
  }
}

function applyFilters() {
  let filteredList = completeList.value;

  if (filters.activity) {
    filteredList = filteredList.filter((worker) => worker.TrabajadorElementoProduccion?.[0]?.ActividadProduccion
      && worker.TrabajadorElementoProduccion[0].ActividadProduccion.Id === filters.activity?.Id);
  }

  if (filters.productionLine) {
    filteredList = filteredList.filter((worker) => worker.TrabajadorElementoProduccion?.[0]?.LineaProduccion
      && worker.TrabajadorElementoProduccion[0].LineaProduccion.Id === filters.productionLine?.Id);
  }

  if (filters.workersGroup) {
    filteredList = filteredList.filter((worker) => worker.GruposTrabajadores?.[0]
      && worker.GruposTrabajadores[0].Id === filters.workersGroup?.Id);
  }

  if (searchWorkerNameValue.value) {
    filteredList = filteredList.filter((worker) => worker.Sujeto?.Nombre?.toLowerCase().includes(searchWorkerNameValue.value.toLowerCase()));
  }

  workersListFilter.value = filteredList;
}

/**
 * @param {LineaProduccion | null} val
 * @returns {void}
 */
function eventSelectedProductionLineFilter(val) {
  filters.productionLine = val;
  applyFilters();
}

/**
 * @param {ActividadProduccion | null} val
 * @returns {void}
 */
function eventSelectedProductionActivityFilter(val) {
  filters.activity = val;
  applyFilters();
}

/**
 * @param {GrupoTrabajadores | null} val
 * @returns {void}
 */
function eventSelectedWorkersGroupFilter(val) {
  filters.workersGroup = val;
  applyFilters();
}

function handleWorkersFilterConfirmation() {
  workersList.value = workersListFilter.value.filter((f) => f.checked);
  popupNewRecords.value = false;
}

function handleGenerateRecord() {
  if (!selectedActivity.value) {
    HiNotification.Toast('Debes seleccionar la actividad de producción');
    return;
  }

  if (isProductionActivity(selectedActivity.value) && !selectedProductionLine.value) {
    HiNotification.Toast('Debes seleccionar la línea de producción');
    return;
  }

  const validWorkers = workersList.value.filter((f) => f.checked
    && (
      (f.TrabajadorElementoProduccion?.[0] && (new Date(f.TrabajadorElementoProduccion[0].FechaInicio) <= new Date(dateRedWorker.value)))
      || f.TrabajadorElementoProduccion?.length === 0));

  if (validWorkers.length > 0 && validWorkers.length < workersList.value.length) {
    HiNotification.Toast('Solo se creará marcaje para aquellos trabajadores que estén dentro del horario permitido');
  }

  const marcajeObjects = validWorkers.map((worker) => {
    /** @type {PartialDeep<MarcajeCerco>} */
    const objMarcaje = {
      Id: 0,
      Trabajador: worker,
      ActividadProduccion: selectedActivity.value,
      LineaProduccion: selectedProductionLine.value,
      FechaHora: HiDateTimeSupport.FormatDateTime(dateRedWorker.value, ''),
    };
    return objMarcaje;
  });

  if (marcajeObjects.length > 0) {
    makeNewRecordWorker(marcajeObjects);
  } else {
    HiNotification.Toast('No se puede crear el marcaje. Trabajadores fuera de rango permitido.');
  }
}

/**
 * @param {string} params
 */
function activityCodeSearch(params) {
  return APIErp.callProductionActivitySearchCode(params);
}

function activityList() {
  if (selectedProductionLine.value != null) {
    return APIErp.callProductionActivityListXLineAuthorized(selectedProductionLine.value.Id);
  }
  return APIErp.callProductionActivityListAuthorized();
}

function productionLineList() {
  return selectedActivity.value
    ? APIErp.callLinesListXActivity(selectedActivity.value.Id)
    : APIErp.callProductionLineListAuthorized();
}

/**
 * @param {string} value
 * @returns {Promise<void>}
 */
async function getProductionElementWorkerByDate(value) {
  if (!userEnviroment.value) {
    return;
  }

  HiDialog.Preloader(true);

  try {
    const { data } = await callExecuteSPERP(
      'APPTRAZABILIDAD_TrabajadorElementoProduccionAFecha',
      [
        { NombreParametro: 'filtro', Valor: `code:${value}` },
        { NombreParametro: 'Momento', Valor: dateTimeNewRecord.value },
        { NombreParametro: 'idGrupoEmpresarial', Valor: userEnviroment.value.EntornoDeTrabajo.GrupoEmpresarial.Id },
        { NombreParametro: 'PrefijoTrabajadores', Valor: prefijoTrabajadoresAlmacen.value },
      ],
      'TrabajadorJSON',
    );

    /** @type {LocalTrabajador[]} */
    const typedData = Array.isArray(data) ? data : [];

    if (typedData.length === 1) {
      const worker = typedData[0];
      if (worker) {
        worker.checked = true;
        workersList.value.push(worker);
        workersListFilter.value.push(worker);
      }
    } else {
      if (workersListFilter.value.length > 0) {
        workersListFilter.value.forEach((trabajador) => {
          if (trabajador.checked) {
            const trabajadorFiltrado = typedData.find((filtrado) => filtrado.Id === trabajador.Id);
            if (trabajadorFiltrado) {
              trabajadorFiltrado.checked = true;
            }
          }
        });
      }
      workersListFilter.value = [...typedData];
      completeList.value = [...typedData];
      popupNewRecords.value = true;
    }

    searchFieldValue.value = '';
    getProductionLineFilter();
    getProductionActivityFilter();
    getWorkersGroupFilter();
  } catch (error) {
    logError(error);
    HiNotification.Toast(error);
  }

  HiDialog.Preloader(false);
}

/**
 * @param {PartialDeep<MarcajeCerco>[]} listObjMarcaje
 * @returns {Promise<void>}
 */
async function makeNewRecordWorker(listObjMarcaje) {
  HiDialog.Preloader(true, 'Guardando marcaje');

  try {
    const result = await APIErp.callMakeNewRecordsWorkers(listObjMarcaje);
    if (result.data.valor) {
      const currentDate = HiDateTimeSupport.FormatDateTime(
        Date.now(),
        'YYYY-MM-DD HH:mm:ss',
      );
      await APIErp.callRecalculateCurrentAndPreviousDays(0, currentDate);

      HiNotification.Toast('Marcajes realizados correctamente');
      workersList.value = [];
      workersListFilter.value = [];
      searchProductionLineRef.value?.Clear();
      searchActivityRef.value?.Clear();
      timePickerRef.value?.SetTime(new Date());
      datePickerRef.value?.setDate(new Date());
    } else {
      HiNotification.Toast(result.data.mensaje, 4000);
    }
  } catch (error) {
    logError(error);
    HiNotification.Toast(error);
  }

  HiDialog.Preloader(false);
}
</script>

<style lang="scss">
.main-massive-records-new {
  // TODO: Remove when migrated to new styles
  --f7-button-padding-horizontal: 10px;
  --f7-button-height: 44px;
  --f7-block-margin-vertical: 15px;
  //

  --f7-page-bg-color: #fff;

  .content-massive-records-new-filter {
    background-color: var(--his-disabled);

    span {
      color: var(--his-slate-blue);
      font-size: 18px;
      padding: 16px;
    }

    &__block {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px;
      margin: 0;

      &--input {
        background: #fff;
        width: -webkit-fill-available;
        border-radius: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px;
        margin: 0;
      }
    }
  }

  .content-massive-records-new-information {
    background-color: #fff;
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: 2fr 1fr;
    grid-column-gap: 5px;

    &__list {
      border-right: 1px solid var(--his-steel-blue);
    }

    &__data {
      --search-title-color: var(--f7-block-title-text-color);
      --search-title-font-size: 14px;
      --search-title-margin-left: 15px;
      --date-picker-label-color: var(--f7-block-title-text-color);

      padding: 5px;

      &--button {
        padding: 0 15px;
        padding-top: 40px;
      }
    }
  }
}

.new-massive-records-popup {
  .content-massive-records-new-information__list {
    height: calc(100vh - var(--f7-page-navbar-offset) - 60px - 165px - var(--information-bar-height)); /* Altura predeterminada cuando el acordeón está cerrado */
    transition: height 0.3s ease; /* Transición suave para el cambio de altura */

    &.opened {
      height: calc(100vh - var(--f7-page-navbar-offset) - 50px - 255px - var(--information-bar-height)); /* Altura cuando el acordeón está abierto */
      .content-mass-records-information {
        padding: 0;
        margin: 0;
        height: calc(100vh - var(--f7-page-navbar-offset) - 110px - 135px - 60px - var(--information-bar-height));

        .content-mass-records-information__card {
          height: calc(100vh - var(--f7-page-navbar-offset) - 110px - 53px - 135px - 60px - var(--information-bar-height));
        }
      }
    }

    .content-mass-records-information {
      padding: 0;
      margin: 0;
      height: calc(100vh - var(--f7-page-navbar-offset) - 110px - 50px - 60px - var(--information-bar-height));

      &__card {
        height: calc(100vh - var(--f7-page-navbar-offset) - 110px - 53px - 50px - 60px - var(--information-bar-height));
      }

      .card {
        margin-top: 0;
      }
    }
  }

  .content-new-massive-records-popup {
    background-color: #fff;

    &__searchbar {
      --f7-searchbar-input-border-radius: 10px;

      background-color: var(--his-disabled);
      padding: 20px;

      &--title {
        color: var(--his-steel-blue);
        padding-left: 5px;
      }
    }

    &__accordion-list {
      background-color: var(--his-silver);
      --f7-list-item-title-text-color: var(--his-slate-blue);
      --f7-list-item-title-font-size: 15px;
      --f7-list-item-title-font-weight: 400;

      &--content {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-column-gap: 20px;
        margin: 0 10px;

        span {
          color: var(--his-steel-blue);
          font-size: 15px;
        }
      }

      .item-link,
      .item-content,
      .item-inner {
        height: 40px;
        min-height: fit-content;
      }
    }

    &__button {
      display: flex;
      justify-content: center;
      align-items: center;

      .button {
        width: 250px;
      }
    }
  }
}

.new-massive-records-configuration-popup {
  span {
    color: var(--his-slate-blue);
    font-size: 18px;
  }

  .div-qr-search {
    border: 1px solid var(--his-silver);
    background: var(--his-tierra-white);
    border-radius: 8px;
    margin-right: 5px;
    text-align: center;
    padding-top: 5px;
    padding-bottom: 1px;
    padding-right: 4px;
    padding-left: 15px;
    margin-left: 10px;
  }
}

// TODO: REMOVE THIS. This is from the old version.
.content-list-checkbox {
  margin-top: 0;

  .content-list-checkbox-item {
    padding: 8px 0;
    border-bottom: 1px solid var(--his-disabled);

    &__title {
      color: var(--f7-list-item-title-text-color);
      font-size: var(--f7-list-item-title-font-size);
      line-height: var(--f7-list-item-title-line-height);
      font-weight: 600;
      text-overflow: ellipsis;
      display: flex;
      align-items: center;
      justify-content: space-between;

      div {
        display: flex;
        align-items: center;

        label {
          &.checkbox {
            i {
              margin-right: 10px;
            }
          }
        }
      }
    }

    &__subtitle {
      margin-left: 28px;
      font-size: 14px;
      font-weight: 400;
      color: #555f80;
    }
  }
}
</style>
